export default __webpack_public_path__ + "static/media/minhakondor logo.39db573e.png";